import { render, staticRenderFns } from "./Undelegations.vue?vue&type=template&id=ab8347c6&scoped=true&"
import script from "./Undelegations.vue?vue&type=script&lang=js&"
export * from "./Undelegations.vue?vue&type=script&lang=js&"
import style0 from "./Undelegations.vue?vue&type=style&index=0&id=ab8347c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8347c6",
  null
  
)

export default component.exports